import React from "react";
import { useState } from "react";
import styles from "../../style";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getToken } from "../../services";
import Swal from "sweetalert2";

const ExportEm = () => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const formatDate = (date) => {
    return date ? date.toLocaleDateString("en-GB") : "";
  };

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      Swal.fire({
        icon: "warning",
        title: "กรุณากรอกวันที่",
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#3085d6",
      });
    } else {
      const token = getToken();
      const headers = {
        "Content-Type": "application/json",
        id_token: token.idToken,
        access_token: token.accessToken,
      };
      console.log(formatDate(startDate), formatDate(endDate));
      setLoading(true);
      try {
        const filename = `Summary report การใช้บริการส่งไปรษณีย์ ${formatDate(
          startDate
        )}-${formatDate(endDate)}.xlsx`;
        const Url = `
      ${
        process.env.REACT_APP_API_BASE_URL
      }/parcels/download_excel_admin?startDate=${encodeURIComponent(
          formatDate(startDate)
        )}&endDate=${encodeURIComponent(
          formatDate(endDate)
        )}&role=${encodeURIComponent("User")}
        `;
        // const response = await axios.get(Url);
        const response = await fetch(Url, { method: "GET", headers: headers });
        if (response.status !== 200) {
          throw new Error(`Failed to download file: ${response.statusText}`);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        link.click();
      } catch (error) {
        if (error.response && error.response.status === 422) {
          // alert("เกิดข้อผิดพลาดในการดาวน์โหลด");
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาดในการดาวน์โหลด",
            confirmButtonText: "ตกลง",
            confirmButtonColor: "#3085d6",
          });
        } else {
          // alert("ดาวน์โหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
          Swal.fire({
            icon: "error",
            title: "ดาวน์โหลดไม่สำเร็จ",
            text: "กรุณาลองใหม่อีกครั้ง",
            confirmButtonText: "ตกลง",
            confirmButtonColor: "#3085d6",
          });
          console.error("Error download data:", error);
        }
      }
    }
    setLoading(false);
  };

  return (
    <div>
      <p className={`${styles.pageHeading}`}>เอกสารรายงานพัสดุในนามบริษัท</p>
      <div className={`${styles.adminPageBox} mt-12`}>
        <div className={`${styles.cardContainer}`}>
          <div className={`${styles.adminGrids} ${styles.adminPageBox}`}>
            <div className="">
              <label className="label">
                <span className="label-text">จากวันที่</span>
              </label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="เลือกวันที่"
                className="input input-bordered w-full"
                required
              />
            </div>
            <div className="">
              <label className="label">
                <span className="label-text">ถึงวันที่</span>
              </label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="เลือกวันที่"
                className="input input-bordered w-full"
                required
              />
            </div>
            <div className="">
              <label className="label">
                <span className="label-text">
                  <br></br>
                </span>
              </label>
              <button
                className={`${styles.adminPageBtn} rounded-md hover:bg-hoverBackground`}
                onClick={handleDownload}
              >
                ดาวน์โหลดข้อมูล
              </button>
            </div>
          </div>
        </div>
        <div className="px-0">
          {loading ? (
            <div
              role="status"
              className="flex items-center justify-center h-screen"
            >
              <svg
                aria-hidden="true"
                className="inline w-12 h-12 text-gray-200 animate-spin dark:text-borderLine fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExportEm;
